export default __webpack_public_path__ + "static/media/twitter_icon.6630c3d3.svg";